/** Частые вопросы на маркетинговом лендинге */
export const LANDING_FAQ = [
  {
    q: 'Кому подойдёт AI-Tenders?',
    a: 'Командам, которые ежедневно ищут и разбирают закупки в России и Казахстане: тендерным специалистам, руководителям направлений и коммерческим отделам.',
  },
  {
    q: 'Это замена поиску закупок?',
    a: 'Платформа объединяет поиск по площадкам РФ и Казахстана и добавляет AI-разбор карточки закупки: риски, критерии, позиции, прогноз и ответы по документам.',
  },
  {
    q: 'Нужно что-то устанавливать на компьютер?',
    a: 'Нет. Достаточно браузера и доступа в интернет.',
  },
  {
    q: 'С какими закупками работает система?',
    a: 'С закупками из подключенных источников России и Казахстана, включая типовые сценарии по 44-ФЗ и 223-ФЗ.',
  },
  {
    q: 'ИИ принимает решение за нас?',
    a: 'Нет. Система готовит структурированную сводку и подсказки. Подписывать заявку, нести ответственность и согласовывать с юристами и руководством — по-прежнему ваша организация.',
  },
  {
    q: 'Сколько времени экономится на одной закупке?',
    a: 'Зависит от объёма документации. Обычно первичный разбор сокращается с часов до десятков минут за счёт автоматизации поиска и чтения документов.',
  },
  {
    q: 'Как получить доступ к системе?',
    a: 'Оставьте заявку на лендинге — команда свяжется и согласует формат подключения под ваш процесс.',
  },
  {
    q: 'Как обрабатываются документы закупки?',
    a: 'Файлы обрабатываются в рамках вашего рабочего контура сервиса. Не загружайте в чат лишние персональные данные; соблюдайте внутренние правила ИБ и политику конфиденциальности сервиса.',
  },
  {
    q: 'С чего начать работу?',
    a: 'После подключения настройте поиск по вашему направлению, откройте релевантные закупки и запустите AI-разбор по документам.',
  },
  {
    q: 'Можно ли подключить аккаунт Tenderplan?',
    a: 'Да. В личном кабинете укажите API-ключ Tenderplan — ваши поисковые ключи подтянутся в сервис. Без ключа доступен встроенный поиск по площадкам РФ и Казахстана.',
  },
]
